import { IntlKey } from 'locales';
import { FormattedMessage, useIntl } from 'react-intl';

import { CorrelationData, CorrelationDataNext } from './Correlation.model';

export interface CorrelationTableProps {
  correlations?: CorrelationData;
  correlationsNext?: ReadonlyArray<CorrelationDataNext>;
}

export function CorrelationTableNext(props: CorrelationTableProps) {
  const { formatNumber } = useIntl();

  return (
    <>
      <table className="table table-sm my-0 bg-lvl1 table-striped">
        <tbody>
          {props.correlationsNext?.map(correlation => (
            <tr key={correlation.label}>
              <th scope="row">
                <FormattedMessage id={`correlation.${correlation.label}` as IntlKey} />
              </th>
              <td>{correlation.value ? formatNumber(correlation.value, { maximumFractionDigits: 2 }) : undefined}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </>
  );
}
